export const FIELDS = {
  ACTIVE: 'active',
  CONTACT_EMAIL: 'contactEmail',
  CONTACT_ID: 'contactId',
  CONTACT_NAME: 'contactName',
  CONTACT_PHONE: 'contactPhone',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  CREATED_BY_USER_ID: 'createdByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  DATE_SENT: 'dateSent',
  ID: 'id',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  NOTE: 'note',
  RFP_ID: 'rfpId',
  SENT_BY_USER_ID: 'sentByUserId',
  STATUS_ID: 'statusId',
  STATUS_NAME: 'statusName',
  VENDOR_ID: 'vendorId',
  VENDOR_NAME: 'vendorName',
};
